var AlligatorView, Backbone, SharedUtilHelper, SupportThanksForContactingTemplate, SupportTicketSuccessView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../thanks_for_contacting.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

AlligatorView = require('../../../shared/frontend/views/alligator_view');

SharedUtilHelper = require('../../../shared/frontend/helpers/utils');

SupportUtilsHelper = require('../helpers/utils');

SupportTicketSuccessView = (function(superClass) {
  extend(SupportTicketSuccessView, superClass);

  function SupportTicketSuccessView() {
    return SupportTicketSuccessView.__super__.constructor.apply(this, arguments);
  }

  SupportTicketSuccessView.prototype.className = 'ticket-success';

  SupportTicketSuccessView.prototype.events = {
    'click #needHelpAgain': "needMoreHelpHandler"
  };

  SupportTicketSuccessView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportThanksForContactingTemplate;
    return this.id = 'ticket-success';
  };

  SupportTicketSuccessView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.hideComponents();
    return this.showComponents();
  };

  SupportTicketSuccessView.prototype.toHash = function() {
    var hash, merchantName, ref, ref1;
    merchantName = ((ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0) || "";
    hash = {
      currentUser: currentUser,
      showFooter: this.shouldShowFooter(),
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      merchant_to_contact: I18n.translate('js.modules.support.merchant_to_contact', {
        merchantName: merchantName
      }),
      refund_request_submitted: this.isRefundEligible(),
      greeting_text: this.getGreetingText(),
      showDefaultThankYouMsg: true,
      isDefaultflow: true
    };
    this.setGetBackMsgType(hash);
    return hash;
  };

  SupportTicketSuccessView.prototype.shouldShowFooter = function() {
    var isLayoutViewEnabled;
    isLayoutViewEnabled = AlligatorView.isWidgetLayoutEnabled;
    return checkIfIsUSByCountry(window.country.name) && !isLayoutViewEnabled;
  };

  SupportTicketSuccessView.prototype.getGreetingText = function() {
    if (this.isRefundEligible()) {
      return I18n.translate('js.modules.support.request_submitted_successfully');
    } else {
      return I18n.translate('js.modules.support.thankcs');
    }
  };

  SupportTicketSuccessView.prototype.isRefundEligible = function() {
    return Groupon.Support.ContentModel.isRefundEligible;
  };

  SupportTicketSuccessView.prototype.setGetBackMsgType = function(hash) {
    if (this.isUrgentTicket()) {
      return hash.twoHoursGetBackMsg = true;
    } else {
      return hash.defaultGetBackmsg = true;
    }
  };

  SupportTicketSuccessView.prototype.isUrgentTicket = function() {
    if (isUS() && checkIfCategoryIsAboutEditingOrCancelling()) {
      return (isCurrentOrderGoodsDeal() && isOrderPurchasedWithinHours(2)) || (isCurrentOrderLiveDeal() && isOrderPurchasedWithinHours(24));
    } else {
      return false;
    }
  };

  SupportTicketSuccessView.prototype.hideComponents = function() {
    SupportUtilsHelper.hideFloatingBoldChat();
    if (!window.isUS()) {
      $('.module-body.intl-footer').children().addClass('hide');
      return $('.module-body.intl-footer').addClass('hidden-footer-content-intl');
    }
  };

  SupportTicketSuccessView.prototype.showComponents = function() {
    return AlligatorView.showWidgets('ticket-success');
  };

  SupportTicketSuccessView.prototype.needMoreHelpHandler = function() {
    return redirectToHelpWizard();
  };

  SupportTicketSuccessView.prototype.close = function() {};

  return SupportTicketSuccessView;

})(Backbone.View);

module.exports = SupportTicketSuccessView;

//# sourceMappingURL=data:application/json;base64,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
